import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form } from '@/components';
import classes from './ProjectsConstructorFormControls.module.scss';

type PropsType = {
  onCancel?: () => void;
  isCancelButton?: boolean;
};

export const ProjectsConstructorFormControls = ({ onCancel, isCancelButton }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });

  return (
    <>
      {isCancelButton ? (
        <div className={classes.formControls}>
          <Form.Submit icon={<CheckOutlined className={classes.submitButtonIcon} />} />
          <Button
            className={classes.cancelButton}
            onClick={onCancel}
            icon={<CloseOutlined className={classes.cancelButtonIcon} />}
          />
        </div>
      ) : (
        <Form.Submit size="middle" className={classes.buttonText} type="primary">
          {t('add')}
        </Form.Submit>
      )}
    </>
  );
};
